import { styled } from '@mui/material/styles';

export const Legend = styled('legend')({
  color: (theme) => theme.palette.primary.main,
  fontWeight: 'bold',
  paddingBottom: '8px'
});
